// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const JenisPengikatanCodeService = {};

JenisPengikatanCodeService.getJenisPengikatanCodeList = function (userInput) {
  return lossClient({
    url: "/JenisPengikatan/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default JenisPengikatanCodeService;
